import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import './styles.css';
import Models from './../models/list';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import IconCollapse from 'material-ui/svg-icons/navigation/expand-less';
import MenuItem from './menu-item';
import { getPictureUrlFromBase64 } from './../../../../../utils/index';
import { listenToPicturesByIds } from './../../../../../actions/pictures';

class Category extends Component {
  constructor() {
    super();
    this.state = {opened: false, renderModels: false};
    this.categoryStyle = {
      display: 'flex',
      padding: '12px',
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
      width: '600px',
      flexDirection: 'column',
      position: 'relative',
      background: '#fff',
      transition: 'width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    }
    this.containerStyle = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '4px',
      paddingBottom: '4px',
      cursor: 'pointer',
      // transition: 'width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    }
    this.containerOpenStyle = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '4x',
      paddingBottom: '4px',
      background: '#F44336',
      // transition: 'width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    }
  }

  static propTypes = {
    category: PropTypes.object,
    categoryGuid: PropTypes.string,
    pictures: PropTypes.object
  }

  renderCollapse = () => (
    <div >
      <IconButton
        style={{height: '36px', width: '36px', padding: '5px'}}
        iconStyle={{fill: 'white'}}
        onClick={
          (e) => {
            e.stopPropagation();
            this.setState({ opened: false });
          }
        }
      >
        <IconCollapse></IconCollapse>
      </IconButton>
    </div>
  )

  componentDidUpdate() {
    this.state.opened && !this.state.renderModels &&
    setTimeout(() => {
      this.setState({ renderModels: true})
    }, 350);
  }

  componentWillUpdate() {

  }

  listenToAccessoriesPict = () => {
  }

  renderNav() {
    const style = {
      display: 'flex',
      position: 'absolute',
      top: '10px',
      right: '10px',
      flexDirection: 'column',
      alignItems: 'center',
    }
    const { categoryGuid } = this.props;
    return (
      <div style={style}>
        <MenuItem menuKey={'details.' + categoryGuid} navElemType='Подробнее'/>
        <MenuItem menuKey={'accessories.' + categoryGuid} navElemType='Аксессуары'/>
        <MenuItem menuKey={'advertisement.' + categoryGuid} navElemType='Рекламные материалы'/>
      </div>
    );
  }

  preparecategoryPlateStyle = () => {
    if (this.state.opened) {
      return { ...this.categoryStyle, width: '100%', background: '#F44336', minHeight: '200px' };
    } else {
      return this.categoryStyle;
    }
  }

  render() {

    const { category, categoryGuid, pictures } =  this.props;

    const url = getPictureUrlFromBase64(pictures[category[categoryGuid].picture]);
    const pictureStyle = {
      backgroundClip: 'content-box',
      backgroundImage: 'url("' + url + '")',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      position: 'absolute',
      left: '10px',
      top: '0px',
      width: '80px',
      height: '40px',
      backgroundRepeat: 'no-repeat'
    };

    return (
      <div
        style={this.state.opened ? this.containerOpenStyle : this.containerStyle}
        className='categoryContainer'
      >
        <Paper
          transitionEnabled={false}
          zDepth={this.state.opened ? 0 : 1}
          style={this.preparecategoryPlateStyle()}
          className={this.state.opened ? 'categoryPlate_no-hover' : 'categoryPlate'}
          key={categoryGuid}
          onClick={() => {
            const curStateOpen = this.state.opened;
            this.setState({ opened: !this.state.opened });
            curStateOpen === false && this.setState({ renderModels: false });
          }}
        >
          { !this.state.opened && <div className='categoryPicture' style={pictureStyle}></div>}
          <div className='categoryDescAndCollapsIcon' style={{display: 'flex', alignItems: 'center'}}>
            <div className='categoryItemDescr' style={{display: 'flex', position: 'relative', color: this.state.opened ? '#fff': '#555'}}>
              {category[categoryGuid].descr}
            </div>
            {this.state.opened && this.renderCollapse()}
          </div>
          {this.state.opened && this.state.renderModels && <Models categoryGuid={categoryGuid} />}
        </Paper>
        {this.state.opened && this.renderNav()  }

      </div>
    );
  }

};

const mapStateToProps = (state, ownProps)  => {
  return {  pictures: state.pictures };
}

export default connect(
  mapStateToProps,
  { listenToPicturesByIds }
)(Category);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/category/item.js